import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";
import { ICreateBriefConfigTaskRequest } from "@shared/lib/types/briefConfig";
import { ToastService } from "@shared/lib/services";

export function useCreateBriefConfigTask(briefId: string) {
  const {
    mutate: createTask,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: ({ data }: { data: ICreateBriefConfigTaskRequest }) =>
      BriefConfigService.createBriefConfigTask(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    createTask,
    isCreating,
    isCreated,
  };
}
